// extracted by mini-css-extract-plugin
module.exports = {"primary":"s_F","secondary":"s_G"};